import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CreateCourse from "@/pages/CreateCourse";
import ExistingCourse from "@/pages/ExistingCourse";
import TakeCourse from "@/pages/TakeCourse";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import FileDownload from "@/components/FileDownload";

// Courses
import CourseCircuits1 from "@/pages/courses/CourseCircuits1";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/create-course",
    name: "CreateCourse",
    component: CreateCourse
  },
  {
    path: "/existing-course",
    name: "ExistingCourse",
    component: ExistingCourse
  },
  {
    path: "/take-course",
    name: "TakeCourse",
    component: TakeCourse
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: Contact
  },
  {
    path: "/docs/:id",
    name: "FileDownload",
    component: FileDownload
  },
  {
    path: "/courses/hvu-circuits1/tour",
    name: "CourseCircuits1",
    component: CourseCircuits1
  },
  {
    path: "*",
    name: "404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
